import script from "./MessageCards.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageCards.vue?vue&type=script&lang=ts&setup=true"

import "./MessageCards.vue?vue&type=style&index=0&id=62fc5a2e&lang=scss"

const __exports__ = script;

export default __exports__